import React from 'react';
import {WithRouterProps} from 'react-router';

import albeyWaving from 'assets/images/albey/waving_pose.svg';
import JoinClassroomForm from 'client/Classrooms/JoinClassroom/JoinClassroomForm';
import JoinClassroomInput from 'client/Classrooms/JoinClassroom/JoinClassroomInput';
import JoinClassroomSubmitButton from 'client/Classrooms/JoinClassroom/JoinClassroomSubmitButton';
import {Text} from '@albert-io/atomic';
import useOnClassroomEnrollment from './hooks/useOnClassroomEnrollment';
import {useStudentHomepageStore} from './useStudentHomepageStore';

export default function Welcome({params}: WithRouterProps) {
  const classroomId: string | undefined = params.classroomId;
  const onClassroomEnrollment = useOnClassroomEnrollment();

  const showJoinClassModal = useStudentHomepageStore((state) => state.showJoinClassModal);

  function onEnrollSuccess() {
    onClassroomEnrollment(classroomId);
  }

  return (
    <div className='flex flex-col items-center gap-x14 p-x5 m:flex-row m:justify-center'>
      <div className='w-[250px]'>
        <Text className='mb-x3 block font-black' size='xl'>
          Welcome to Albert!
        </Text>
        <JoinClassroomForm onEnrollSuccess={onEnrollSuccess}>
          <JoinClassroomInput className='mb-x1-half' hideLabel inert={showJoinClassModal} />
          <JoinClassroomSubmitButton className='w-full rounded-full' inert={showJoinClassModal} />
        </JoinClassroomForm>
      </div>
      <img alt='Illustration of Albey waving' className='w-x10 m:w-x20' src={albeyWaving} />
    </div>
  );
}
